import React from 'react';

const MinusIcon: React.FC = () => {
  return (
    <svg width="12" height="3" viewBox="0 0 12 3" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.6668 1.5L1.3335 1.5L10.6668 1.5Z" fill="#242424" />
      <path
        d="M10.6668 1.5L1.3335 1.5"
        stroke="#242424"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MinusIcon;
